// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WishlistRouteImport } from './routes/wishlist'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MfaChallengeRouteImport } from './routes/mfa-challenge'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LeaderboardRouteImport } from './routes/leaderboard'
import { Route as JournalRouteImport } from './routes/journal'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DiscoverRouteImport } from './routes/discover'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as CreatorsRouteImport } from './routes/creators'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as ApplicationStatusRouteImport } from './routes/application-status'
import { Route as AdvertiseRouteImport } from './routes/advertise'
import { Route as AdminLoginRouteImport } from './routes/admin-login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductIdRouteImport } from './routes/product.$id'
import { Route as JournalWhyCuratedStorefrontsOutperformLinkInBioRouteImport } from './routes/journal_.why-curated-storefronts-outperform-link-in-bio'
import { Route as JournalPluggzVsAmazonInfluencerProgramRouteImport } from './routes/journal_.pluggz-vs-amazon-influencer-program'
import { Route as JournalHowToStartACreatorStorefrontRouteImport } from './routes/journal_.how-to-start-a-creator-storefront'
import { Route as JournalHowToBuildAStorefrontThatConvertsRouteImport } from './routes/journal_.how-to-build-a-storefront-that-converts'
import { Route as JournalGuideToCreatorStorefrontsRouteImport } from './routes/journal_.guide-to-creator-storefronts'
import { Route as JournalCreatorsGuideToAffiliateCommissionsRouteImport } from './routes/journal_.creators-guide-to-affiliate-commissions'
import { Route as EmbedHandleRouteImport } from './routes/embed.$handle'
import { Route as CreatorHandleRouteImport } from './routes/creator.$handle'
import { Route as CategorySlugRouteImport } from './routes/category.$slug'
import { Route as BioHandleRouteImport } from './routes/bio.$handle'
import { Route as AuthConfirmRouteImport } from './routes/auth.confirm'
import { Route as AuthenticatedShopperProfileRouteImport } from './routes/_authenticated.shopper-profile'
import { Route as AuthenticatedPrivacySettingsRouteImport } from './routes/_authenticated.privacy-settings'
import { Route as AuthenticatedCreatorPayoutsRouteImport } from './routes/_authenticated.creator-payouts'
import { Route as AuthenticatedCreatorDashboardRouteImport } from './routes/_authenticated.creator-dashboard'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated.admin'
import { Route as WishlistShareTokenRouteImport } from './routes/wishlist.share.$token'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated.admin.index'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated.admin.settings'
import { Route as AuthenticatedAdminProductsRouteImport } from './routes/_authenticated.admin.products'
import { Route as AuthenticatedAdminPayoutsRouteImport } from './routes/_authenticated.admin.payouts'
import { Route as AuthenticatedAdminPartnershipsRouteImport } from './routes/_authenticated.admin.partnerships'
import { Route as AuthenticatedAdminLooksRouteImport } from './routes/_authenticated.admin.looks'
import { Route as AuthenticatedAdminCreatorsRouteImport } from './routes/_authenticated.admin.creators'
import { Route as AuthenticatedAdminContactRouteImport } from './routes/_authenticated.admin.contact'
import { Route as AuthenticatedAdminCommissionsRouteImport } from './routes/_authenticated.admin.commissions'
import { Route as AuthenticatedAdminAuditRouteImport } from './routes/_authenticated.admin.audit'
import { Route as AuthenticatedAdminAffiliatesRouteImport } from './routes/_authenticated.admin.affiliates'
import { Route as AuthenticatedAdminCreatorsIndexRouteImport } from './routes/_authenticated.admin.creators.index'
import { Route as AuthenticatedAdminCreatorsIdRouteImport } from './routes/_authenticated.admin.creators.$id'

const WishlistRoute = WishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const MfaChallengeRoute = MfaChallengeRouteImport.update({
            id: '/mfa-challenge',path: '/mfa-challenge',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const LeaderboardRoute = LeaderboardRouteImport.update({
            id: '/leaderboard',path: '/leaderboard',getParentRoute: () => rootRouteImport
          })
const JournalRoute = JournalRouteImport.update({
            id: '/journal',path: '/journal',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const DiscoverRoute = DiscoverRouteImport.update({
            id: '/discover',path: '/discover',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const CreatorsRoute = CreatorsRouteImport.update({
            id: '/creators',path: '/creators',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ApplyRoute = ApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => rootRouteImport
          })
const ApplicationStatusRoute = ApplicationStatusRouteImport.update({
            id: '/application-status',path: '/application-status',getParentRoute: () => rootRouteImport
          })
const AdvertiseRoute = AdvertiseRouteImport.update({
            id: '/advertise',path: '/advertise',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin-login',path: '/admin-login',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProductIdRoute = ProductIdRouteImport.update({
            id: '/product/$id',path: '/product/$id',getParentRoute: () => rootRouteImport
          })
const JournalWhyCuratedStorefrontsOutperformLinkInBioRoute = JournalWhyCuratedStorefrontsOutperformLinkInBioRouteImport.update({
            id: '/journal_/why-curated-storefronts-outperform-link-in-bio',path: '/journal/why-curated-storefronts-outperform-link-in-bio',getParentRoute: () => rootRouteImport
          })
const JournalPluggzVsAmazonInfluencerProgramRoute = JournalPluggzVsAmazonInfluencerProgramRouteImport.update({
            id: '/journal_/pluggz-vs-amazon-influencer-program',path: '/journal/pluggz-vs-amazon-influencer-program',getParentRoute: () => rootRouteImport
          })
const JournalHowToStartACreatorStorefrontRoute = JournalHowToStartACreatorStorefrontRouteImport.update({
            id: '/journal_/how-to-start-a-creator-storefront',path: '/journal/how-to-start-a-creator-storefront',getParentRoute: () => rootRouteImport
          })
const JournalHowToBuildAStorefrontThatConvertsRoute = JournalHowToBuildAStorefrontThatConvertsRouteImport.update({
            id: '/journal_/how-to-build-a-storefront-that-converts',path: '/journal/how-to-build-a-storefront-that-converts',getParentRoute: () => rootRouteImport
          })
const JournalGuideToCreatorStorefrontsRoute = JournalGuideToCreatorStorefrontsRouteImport.update({
            id: '/journal_/guide-to-creator-storefronts',path: '/journal/guide-to-creator-storefronts',getParentRoute: () => rootRouteImport
          })
const JournalCreatorsGuideToAffiliateCommissionsRoute = JournalCreatorsGuideToAffiliateCommissionsRouteImport.update({
            id: '/journal_/creators-guide-to-affiliate-commissions',path: '/journal/creators-guide-to-affiliate-commissions',getParentRoute: () => rootRouteImport
          })
const EmbedHandleRoute = EmbedHandleRouteImport.update({
            id: '/embed/$handle',path: '/embed/$handle',getParentRoute: () => rootRouteImport
          })
const CreatorHandleRoute = CreatorHandleRouteImport.update({
            id: '/creator/$handle',path: '/creator/$handle',getParentRoute: () => rootRouteImport
          })
const CategorySlugRoute = CategorySlugRouteImport.update({
            id: '/category/$slug',path: '/category/$slug',getParentRoute: () => rootRouteImport
          })
const BioHandleRoute = BioHandleRouteImport.update({
            id: '/bio/$handle',path: '/bio/$handle',getParentRoute: () => rootRouteImport
          })
const AuthConfirmRoute = AuthConfirmRouteImport.update({
            id: '/auth/confirm',path: '/auth/confirm',getParentRoute: () => rootRouteImport
          })
const AuthenticatedShopperProfileRoute = AuthenticatedShopperProfileRouteImport.update({
            id: '/shopper-profile',path: '/shopper-profile',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPrivacySettingsRoute = AuthenticatedPrivacySettingsRouteImport.update({
            id: '/privacy-settings',path: '/privacy-settings',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreatorPayoutsRoute = AuthenticatedCreatorPayoutsRouteImport.update({
            id: '/creator-payouts',path: '/creator-payouts',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedCreatorDashboardRoute = AuthenticatedCreatorDashboardRouteImport.update({
            id: '/creator-dashboard',path: '/creator-dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRoute
          })
const WishlistShareTokenRoute = WishlistShareTokenRouteImport.update({
            id: '/share/$token',path: '/share/$token',getParentRoute: () => WishlistRoute
          })
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminSettingsRoute = AuthenticatedAdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminProductsRoute = AuthenticatedAdminProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPayoutsRoute = AuthenticatedAdminPayoutsRouteImport.update({
            id: '/payouts',path: '/payouts',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminPartnershipsRoute = AuthenticatedAdminPartnershipsRouteImport.update({
            id: '/partnerships',path: '/partnerships',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminLooksRoute = AuthenticatedAdminLooksRouteImport.update({
            id: '/looks',path: '/looks',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCreatorsRoute = AuthenticatedAdminCreatorsRouteImport.update({
            id: '/creators',path: '/creators',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminContactRoute = AuthenticatedAdminContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCommissionsRoute = AuthenticatedAdminCommissionsRouteImport.update({
            id: '/commissions',path: '/commissions',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAuditRoute = AuthenticatedAdminAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminAffiliatesRoute = AuthenticatedAdminAffiliatesRouteImport.update({
            id: '/affiliates',path: '/affiliates',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedAdminCreatorsIndexRoute = AuthenticatedAdminCreatorsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedAdminCreatorsRoute
          })
const AuthenticatedAdminCreatorsIdRoute = AuthenticatedAdminCreatorsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedAdminCreatorsRoute
          })





const AuthenticatedAdminCreatorsRouteChildren = {
  AuthenticatedAdminCreatorsIdRoute: AuthenticatedAdminCreatorsIdRoute,AuthenticatedAdminCreatorsIndexRoute: AuthenticatedAdminCreatorsIndexRoute
}

const AuthenticatedAdminCreatorsRouteWithChildren = AuthenticatedAdminCreatorsRoute._addFileChildren(AuthenticatedAdminCreatorsRouteChildren)



const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAffiliatesRoute: AuthenticatedAdminAffiliatesRoute,AuthenticatedAdminAuditRoute: AuthenticatedAdminAuditRoute,AuthenticatedAdminCommissionsRoute: AuthenticatedAdminCommissionsRoute,AuthenticatedAdminContactRoute: AuthenticatedAdminContactRoute,AuthenticatedAdminCreatorsRoute: AuthenticatedAdminCreatorsRouteWithChildren,AuthenticatedAdminLooksRoute: AuthenticatedAdminLooksRoute,AuthenticatedAdminPartnershipsRoute: AuthenticatedAdminPartnershipsRoute,AuthenticatedAdminPayoutsRoute: AuthenticatedAdminPayoutsRoute,AuthenticatedAdminProductsRoute: AuthenticatedAdminProductsRoute,AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedCreatorDashboardRoute: AuthenticatedCreatorDashboardRoute,AuthenticatedCreatorPayoutsRoute: AuthenticatedCreatorPayoutsRoute,AuthenticatedPrivacySettingsRoute: AuthenticatedPrivacySettingsRoute,AuthenticatedShopperProfileRoute: AuthenticatedShopperProfileRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const WishlistRouteChildren = {
  WishlistShareTokenRoute: WishlistShareTokenRoute
}

const WishlistRouteWithChildren = WishlistRoute._addFileChildren(WishlistRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AdminLoginRoute: AdminLoginRoute,AdvertiseRoute: AdvertiseRoute,ApplicationStatusRoute: ApplicationStatusRoute,ApplyRoute: ApplyRoute,ContactRoute: ContactRoute,CreatorsRoute: CreatorsRoute,DemoRoute: DemoRoute,DiscoverRoute: DiscoverRoute,ForgotPasswordRoute: ForgotPasswordRoute,JournalRoute: JournalRoute,LeaderboardRoute: LeaderboardRoute,LoginRoute: LoginRoute,MfaChallengeRoute: MfaChallengeRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,WishlistRoute: WishlistRouteWithChildren,AuthConfirmRoute: AuthConfirmRoute,BioHandleRoute: BioHandleRoute,CategorySlugRoute: CategorySlugRoute,CreatorHandleRoute: CreatorHandleRoute,EmbedHandleRoute: EmbedHandleRoute,JournalCreatorsGuideToAffiliateCommissionsRoute: JournalCreatorsGuideToAffiliateCommissionsRoute,JournalGuideToCreatorStorefrontsRoute: JournalGuideToCreatorStorefrontsRoute,JournalHowToBuildAStorefrontThatConvertsRoute: JournalHowToBuildAStorefrontThatConvertsRoute,JournalHowToStartACreatorStorefrontRoute: JournalHowToStartACreatorStorefrontRoute,JournalPluggzVsAmazonInfluencerProgramRoute: JournalPluggzVsAmazonInfluencerProgramRoute,JournalWhyCuratedStorefrontsOutperformLinkInBioRoute: JournalWhyCuratedStorefrontsOutperformLinkInBioRoute,ProductIdRoute: ProductIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)